module.exports = __webpack_public_path__ + "img/signOut.e09f99f1.svg";